import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { clearCompleted } from "../../services/progress-notifications/actions";

export default function StackHeader({ aggregate, onMinimize }) {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const subtitle = buildSummary(aggregate, t);
	return (
		<div
			className="pn-stack__head"
			data-testid="progress-stack-header"
			role="presentation"
		>
			<div className="pn-stack__head-left">
				<span className="pn-stack__head-badge" aria-hidden="true">
					{aggregate.total}
				</span>
				<div className="pn-stack__head-text">
					<span className="pn-stack__head-title">
						{t("progressNotifications.header", "Background tasks")}
					</span>
					<span className="pn-stack__head-subtitle" aria-live="off">
						{subtitle}
					</span>
				</div>
			</div>
			<div className="pn-stack__head-actions">
				<button
					type="button"
					className="pn-stack__head-btn"
					aria-label={t("progressNotifications.clearCompleted", "Clear completed")}
					title={t("progressNotifications.clearCompleted", "Clear completed")}
					onClick={() => dispatch(clearCompleted())}
					data-testid="progress-stack-clear-completed"
					disabled={aggregate.done === 0}
				>
					<i className="fas fa-check-double" />
				</button>
				<button
					type="button"
					className="pn-stack__head-btn"
					aria-label={t("progressNotifications.minimize", "Minimize")}
					title={t("progressNotifications.minimize", "Minimize")}
					onClick={onMinimize}
					data-testid="progress-stack-minimize"
				>
					<i className="fas fa-minus" />
				</button>
			</div>
		</div>
	);
}

function buildSummary(aggregate, t) {
	if (aggregate.total === 0) {
		return t("progressNotifications.noTasks", "no tasks");
	}
	return t("progressNotifications.summary", {
		running: aggregate.running,
		done: aggregate.done,
		warnings: aggregate.warnings,
		errors: aggregate.errors,
		defaultValue: `${aggregate.running} running · ${aggregate.done} done · ${aggregate.warnings} partial · ${aggregate.errors} errors`,
	});
}
